import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getErisLoginPath } from 'src/auth/authConfig';
import ErisFooter from 'src/ui/eris/screens/common/footer/ErisFooter';
import ErisHeader from 'src/ui/eris/screens/common/header/ErisHeader';
import { useAuth } from 'src/auth/useAuth';

function AuthCallbackPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { error, status } = useAuth();
  const loginPath = getErisLoginPath();

  useEffect(() => {
    if (status === 'loading' || status === 'authenticated') return;
    navigate(loginPath, { replace: true });
  }, [loginPath, navigate, status]);

  const message =
    status === 'callback_error'
      ? error || t('eris.login.callbackError')
      : t('eris.login.callbackLoading');

  return (
    <div
      className="flex min-h-screen flex-col bg-blue-500"
      style={{ backgroundColor: 'rgb(202, 239, 248)' }}
    >
      <ErisHeader />
      <div className="flex flex-1 items-center justify-center px-4">
        <div
          className="w-full max-w-xl rounded bg-white p-8 text-center"
          style={{ backgroundColor: 'rgb(245, 245, 245)' }}
        >
          <h1 className="mb-4 text-2xl font-bold text-gray-900">{t('eris.login.title')}</h1>
          <p className={status === 'callback_error' ? 'text-red-600' : 'text-gray-800'}>
            {message}
          </p>
        </div>
      </div>
      <ErisFooter />
    </div>
  );
}

export default AuthCallbackPage;
